<template>
	<div>

		<a-modal
		      :title="form.room_id > 0 ? '编辑报告' : '新增报告'"
		      :visible="visible"
		      :confirm-loading="confirmLoading"
		      @ok="handleOk"
		      @cancel="handleCancel"
			  width="850px"
		    >
		    <a-form-model :model="form">
				<a-spin :spinning="showMemberLoading">
					<a-form-model-item required label="选择用户" v-if="JSON.stringify(form.member) == '{}'">
						<div class="alcenter flex">
							<a-input-search v-model="search.mobile" placeholder="请输入用户手机号"  style="width: 160px" @search="onSearch" />
							<div class="ml10 flex alcenter ft12 ftw400 cl-notice" v-if="msgStatus">
								<div>暂无该用户，请重新输入 </div>
								<!-- <div class="cl-theme clickAct" @click="addMemberAct()">或添加会员</div> -->
							</div>
						</div>
					</a-form-model-item>
					
					<a-form-model-item  label="选中的用户" v-if="JSON.stringify(form.member) != '{}'">
						<div class="flex alcenter ml10">
							<div class="flex alcenter">
								<div class="ft14 ftw400 cl-main">昵称：</div>
								<div class="ft14 ftw400 cl-black ml5">{{form.member.nick_name}}</div>
							</div>
							
							<div class="flex alcenter ml20">
								<div class="ft14 ftw400 cl-main">手机号：</div>
								<div class="ft14 ftw400 cl-black ml5">{{form.member.mobile}}</div>
							</div>
							
							<div class=" ml20">
								<a-button type="primary" @click="reChooseAct()">重新选择</a-button>
							</div>
						</div>
					</a-form-model-item>
				</a-spin>

				<a-form-model-item label="选择治疗师" required>
					<div @click="chooseTechnicianAct()" v-if="JSON.stringify(form.technician) == '{}'"  class="choose-technician-box ml10 clickAct flex center alcenter cl-theme ft14 ftw600">
						选择<i class="iconfont iconicon_arrowr ft14 ml5"/>
					</div>
					
					<div v-else class="choose-technician-box flex  space">
						<div class="flex alcenter">
							<img  :src="form.technician.face" class="choose-technician-box-face" style="width:80px;height: 60px;"/>
							<div class="ml10">
								<div class="ft16 ftw600 cl-main text-over4">{{form.technician.name}}</div>
								<div class="mt15 flex alcenter">
									<i class="iconfont iconcall_gray mr5 ft12 cl-notice"/>
									<div class="cl-info ft12 ftw400 text-over4">{{form.technician.mobile}}</div>
								</div>
							</div>
						</div>
						<div class="flex alcenter cente ft14 ftw600 cl-theme clickAct" @click="chooseTechnicianAct()">
							重新选择<i class="iconfont iconicon_arrowr ft14 ml5"/>
						</div>
					</div>
				</a-form-model-item>

		      	<a-form-model-item required label="报告名称">
		      		<a-input v-model="form.name" placeholder="输入报告名称" style="width: 300px;"></a-input>
		      	</a-form-model-item>

				<a-form-model-item required label="所属门店">
					<a-select style="width: 200px;" v-model="form.mendian_id">
						<a-select-option :value="0">请选择</a-select-option>
						<a-select-option v-for="(item,index) in mendians" :key="index" :value="item.mendian_id">{{item.name}}</a-select-option>
					</a-select>
				</a-form-model-item>

				<a-form-model-item label="结果">
					<a-input v-model="form.results"  placeholder="结果" type="textarea"></a-input>
				</a-form-model-item>

				<a-form-model-item label="图片">
					<div>
						<!-- <div class="ft12 cl-notice">建议上传200x200px</div> -->
						<div class="mt12">
							<upload-img v-model="form.img_url"></upload-img>
						</div>
					</div>
				</a-form-model-item>

				<!-- <a-form-model-item label="使用中">
					<a-radio-group v-model="form.is_use">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-model-item>

				<a-form-model-item label="是否隐私">
					<a-radio-group v-model="form.is_yin">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-model-item>

				<a-form-model-item label="关联项目">
					<a-radio-group v-model="form.is_project">
						<a-radio :value="1">是</a-radio>
						<a-radio :value="0">否</a-radio>
					</a-radio-group>
				</a-form-model-item> -->

				<a-form-model-item label="报告解读" required class="mt20">
						<html-edit v-model="form.report_read"></html-edit>
				</a-form-model-item>

				<a-form-model-item label="健康建议" required class="mt20">
						<html-edit v-model="form.health_advice"></html-edit>
				</a-form-model-item>

				<a-form-model-item label="总结" required class="mt20">
						<html-edit v-model="form.summary"></html-edit>
				</a-form-model-item>

				<a-form-model-item label="状态">
					<a-radio-group v-model="form.status">
						<a-radio :value="1">正常</a-radio>
						<a-radio :value="2">关闭</a-radio>
					</a-radio-group>
				</a-form-model-item>
		      	
		    </a-form-model>	
		</a-modal>

		<div v-if="chooseTechnicianVisible">
			<choose-technician v-model="form.technician" :visible="chooseTechnicianVisible" @cancel="cancelChooseTechnician" @ok="okChooseTechnician"></choose-technician>
		</div>
	</div>
</template>

<script>
	import uploadImg from '../../../../components/upload/upload.vue';
	import BaiduMap from '../../../../components/map/baidumap.vue';
	import htmlEdit from '../../../../components/html.vue';
	import chooseTechnician from './modal/chooseTechnician.vue';
	export default {
		components:{
			uploadImg,
			BaiduMap,
			htmlEdit,
			chooseTechnician
		},
		props:{
			datas:{
				type:Object,
				default:function(){
					return new Object;
				}
			},
		},
		data(){
			return {
				confirmLoading:false,
				visible:true,
				form:{
					member:{},
					technician:{}
				},
				mendians:[],
				showMemberLoading:false,
				msgStatus:false,
				search:{
					mobile:''
				},
				chooseTechnicianVisible:false,
			}
		},
		created(){
			this.form = JSON.parse(JSON.stringify(this.datas));
			console.log('this.form',this.form);
			this.visible = true;
			this.getMendians();
		},
		methods:{
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			selectAct(res){
				this.form.lng = res.lng;
				this.form.lat = res.lat;
			},
			handleOk(){
				
				
				if(JSON.stringify(this.form.member) == '{}'){
					this.$message.error('请选择用户');
					return;
				}
				
				if(!this.form.member.member_id){
					this.$message.error('请选择用户');
					return;
				}
				
				if(JSON.stringify(this.form.technician) == '{}'){
					this.$message.error('请选择治疗师');
					return;
				}

				if(this.confirmLoading == true) return;
				this.confirmLoading = true;
				this.$http.api('admin/saveReport',{
					report_id:this.form.report_id,
					name:this.form.name,
					member_id	:this.form.member.member_id,
					technician_id	:this.form.technician.technician_id,
					mendian_id	:this.form.mendian_id,
					results	:this.form.results,
					img_url	:this.form.img_url,
					report_read:this.form.report_read,
					health_advice:this.form.health_advice,
					summary:this.form.summary,
					status	:this.form.status,
				}).then(res=>{
					this.$message.success('操作成功');
					this.confirmLoading = false;
					this.visible = false;
					this.$emit('ok');
				}).catch(res=>{
					this.confirmLoading=false;
				})
			},
			handleCancel(){
				this.visible = false;
				this.$emit('closed');
			},
			//查找会员
			onSearch(){
				if(this.showMemberLoading==true) return;
				this.showMemberLoading=true;
				this.$http.api('admin/getMemberByMobile',{
					mobile:this.search.mobile,
				}).then(res=>{
					this.msgStatus=false;
					this.form.member=res.member;
					this.showMemberLoading=false;
				}).catch(res=>{
					this.showMemberLoading=false;
					this.msgStatus=true;
				})
			},
			reChooseAct(){
				this.msgStatus=false;
				this.form.member=new Object;
			},
			//选择技师
			chooseTechnicianAct(){
				this.chooseTechnicianVisible=true;
			},
			cancelChooseTechnician(){
				this.chooseTechnicianVisible=false;
			},
			okChooseTechnician(){
				this.chooseTechnicianVisible=false;
			},
		}
	}
</script>

<style>
	
</style>